<template>
  <span v-if="temAcesso" class="botao-gerar-ia-wrapper">
    <CButton
      color="primary"
      variant="outline"
      size="sm"
      class="btn-gerar-ia"
      :disabled="gerando"
      @click="abrirModal"
    >
      <fa-icon v-if="gerando" icon="spinner" spin />
      <svg v-else class="ia-sparkles" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z"/>
        <path d="M20 7l.9 2.7L23.6 10.6l-2.7.9L20 14.2l-.9-2.7L16.4 10.6l2.7-.9L20 7z" opacity=".6"/>
        <path d="M5 16l.6 1.8L7.4 18.4l-1.8.6L5 20.8l-.6-1.8L2.6 18.4l1.8-.6L5 16z" opacity=".6"/>
      </svg>
      {{ gerando ? 'Gerando...' : label }}
    </CButton>

    <modal :name="modalName" height="auto" width="600" :scrollable="true" :clickToClose="false">
      <div class="ia-modal">
        <div class="ia-modal__header">
          <h4 class="ia-modal__title">
            <svg class="ia-sparkles ia-sparkles--title" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z"/>
              <path d="M20 7l.9 2.7L23.6 10.6l-2.7.9L20 14.2l-.9-2.7L16.4 10.6l2.7-.9L20 7z" opacity=".6"/>
              <path d="M5 16l.6 1.8L7.4 18.4l-1.8.6L5 20.8l-.6-1.8L2.6 18.4l1.8-.6L5 16z" opacity=".6"/>
            </svg>
            Gerar com IA
          </h4>
          <span class="ia-modal__campo" v-if="campoLabel">{{ campoLabel }}</span>
        </div>
        <div class="ia-modal__body">
          <label class="ia-modal__label">Contexto adicional (opcional)</label>
          <p class="ia-modal__hint">
            Forneça informações extras que a IA deve considerar ao gerar o texto.
            Exemplo: público-alvo, diferenciais, tom de voz desejado, etc.
          </p>
          <textarea
            class="form-control"
            rows="8"
            v-model="contextoAdicional"
            placeholder="Ex: Este produto é voltado para profissionais da construção civil. Destacar durabilidade e custo-benefício..."
            maxlength="10000"
          ></textarea>
          <small class="ia-modal__counter">{{ (contextoAdicional || '').length }} / 10.000 caracteres</small>
        </div>
        <div class="ia-modal__footer">
          <CButton variant="outline" color="secondary" @click="fecharModal">Cancelar</CButton>
          <CButton color="primary" @click="confirmarGeracao" :disabled="gerando">
            <fa-icon v-if="gerando" icon="spinner" spin />
            <svg v-else class="ia-sparkles" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z"/>
              <path d="M20 7l.9 2.7L23.6 10.6l-2.7.9L20 14.2l-.9-2.7L16.4 10.6l2.7-.9L20 7z" opacity=".6"/>
              <path d="M5 16l.6 1.8L7.4 18.4l-1.8.6L5 20.8l-.6-1.8L2.6 18.4l1.8-.6L5 16z" opacity=".6"/>
            </svg>
            {{ gerando ? 'Gerando...' : 'Gerar' }}
          </CButton>
        </div>
      </div>
    </modal>
  </span>
</template>

<script>
import { post } from "@/helpers/apiRequest";
import { loadAuthorizationAction } from "@/helpers/cargas";

export default {
  name: "BotaoGerarIA",
  props: {
    endpoint: { type: String, required: true },
    campo: { type: String, required: true },
    campoLabel: { type: String, default: "" },
    contextoObjeto: { type: Object, default: null },
    valorAtual: { type: String, default: "" },
    label: { type: String, default: "Gerar com IA" },
  },
  data() {
    return {
      gerando: false,
      contextoAdicional: "",
    };
  },
  computed: {
    temAcesso() {
      try {
        return loadAuthorizationAction('ADMIN_CONFIGURACAO_IA', 'GERAR_CONTEUDOS_POR_IA');
      } catch {
        return false;
      }
    },
    modalName() {
      return `iaModal-${this.campo}`;
    },
  },
  methods: {
    abrirModal() {
      this.contextoAdicional = "";
      this.$modal.show(this.modalName);
    },
    fecharModal() {
      this.$modal.hide(this.modalName);
      this.contextoAdicional = "";
    },
    confirmarGeracao() {
      const executar = () => {
        this.gerando = true;
        const payload = { campo: this.campo };

        if (this.contextoAdicional && this.contextoAdicional.trim()) {
          payload.contexto_adicional = this.contextoAdicional.trim();
        }

        if (this.contextoObjeto) {
          payload.contexto_objeto = this.contextoObjeto;
        }

        post(this.endpoint, payload)
          .then((json) => {
            const texto = json.message || json.data || "";
            this.$emit("generated", texto);
            this.gerando = false;
            this.fecharModal();
          })
          .catch((error) => {
            this.gerando = false;
            this.$swal({
              title: "Erro ao gerar conteúdo",
              text: error.message || "Tente novamente mais tarde.",
              icon: "error",
              showConfirmButton: true,
            });
          });
      };

      if (this.valorAtual && this.valorAtual.trim().length > 0) {
        this.$swal({
          title: "Substituir conteúdo?",
          text: "O campo já possui conteúdo. Deseja substituir pelo texto gerado pela IA?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sim, substituir",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed || result.value) {
            executar();
          }
        });
      } else {
        executar();
      }
    },
  },
};
</script>

<style scoped>
.botao-gerar-ia-wrapper {
  display: inline-flex;
  flex-shrink: 0;
}

.btn-gerar-ia {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.ia-sparkles {
  flex-shrink: 0;
}

.ia-sparkles--title {
  color: #3a3e81;
}

/* Modal */
.ia-modal {
  padding: 0;
}

.ia-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
}

.ia-modal__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #3a3e81;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ia-modal__campo {
  font-size: 12px;
  color: #667085;
  background: #f2f2f8;
  padding: 3px 10px;
  border-radius: 12px;
}

.ia-modal__body {
  padding: 16px 20px;
}

.ia-modal__label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.ia-modal__hint {
  font-size: 12px;
  color: #667085;
  margin-bottom: 8px;
  line-height: 1.5;
}

.ia-modal__counter {
  display: block;
  text-align: right;
  color: #999;
  margin-top: 4px;
}

.ia-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #f9f9fb;
}
</style>
